import {Biscuit, getAllUrlParams} from "../../../../utils";
import React, {useEffect, useState} from "react";
import {
    contingentsActions,
    pricesActions,
    priceTariffsActions,
    priceTariffValidFromsActions,
    pricetypesActions, productsActions,
    useSelector
} from "inbooma-api";
import t from "../../../helpers/t";
import showNotification from "../../../helpers/showNotification";
import {$, _} from "../../../../../vendor";
import {createSubmenuItems} from "../../../../utils/Helper";
import PricetariffSidebar from "./PricetariffSidebar";
import InboomaSubmenu from "../../../components/InboomaSubmenu";
import SortNav from "../../../components/SortNav";
import SubItemView from "./SubItemView";
import PricetariffsList from "./PricetariffsList";
import moment from "moment";

const PricetariffsView = (props) => {
    const {dispatch, returnPath, params} = props;
    const currentUrl = new URL(window.location.href);
    const language = Biscuit.get('user.lang').replace('-', '_');
    const searchParams = currentUrl.searchParams;
    const allUrlParams = getAllUrlParams(window.location.href);
    const paginationLimit = 40;
    const [pagination, setPagination] = useState({
        has_next_page: false,
        current_page: 1
    });
    const mainMenu = document.getElementById('inb-main-menu');
    if (mainMenu !== undefined && mainMenu != null && mainMenu.querySelector('.l-contingents')) {
        if (mainMenu.querySelector('.active') != null) mainMenu.querySelector('.active').classList.remove('active');
        mainMenu.querySelector('.l-contingents').classList.add('active');
    }
    const [filters, setFilters] = useState({'find': 'CheckedInStatus', 'sort': 'id', 'direction': 'desc'});
    const _pricetariffs = useSelector(state => state.price_tariffs_data.pricetariffs);
    const _pricetariff = useSelector(state => state.price_tariffs_data.pricetariff);
    const _deletePricetariff = useSelector(state => state.price_tariffs_data.deletePricetariff);
    const _patchPricetariff = useSelector(state => state.price_tariffs_data.patchPricetariff);
    const _pricetariffValidFroms = useSelector(state => state.price_tariff_valid_froms_data.pricetariffValidFroms);
    const _pricetariffValidFrom = useSelector(state => state.price_tariff_valid_froms_data.pricetariffValidFrom);
    const _pricetypes = useSelector(state => state.pricetypes_data.pricetypes);
    const _prices = useSelector(state => state.prices_data.prices);
    const _products = useSelector(state => state.products_data.products);
    const [pricetariffs, setPricetariffs] = useState([]);
    const [selectedEntity, setSelectedEntity] = useState(null);
    const [pricetariffValidFroms, setPricetariffValidFroms] = useState([]);
    const [pricetariff, setPricetariff] = useState(null);
    const [pricetariffValidFrom, setPricetariffValidFrom] = useState(null);
    const [pricetariffValidFromsPending, setPricetariffValidFromsPending] = useState(false);
    const [pricetariffValidFromPending, setPricetariffValidFromPending] = useState(false);
    const [pricetariffsPending, setPricetariffsPending] = useState(false);
    const [pricetariffPending, setPricetariffPending] = useState(false);
    const [deletePricetariffPending, setDeletePricetariffPending] = useState(false);
    const [pricetypesPending, setPricetypesPending] = useState(false);
    const [pricesPending, setPricesPending] = useState(false);
    const [productsPending, setProductsPending] = useState(false);
    const [initialized, setInitialized] = useState(false);
    const [extrasReady, setExtrasReady] = useState(false);
    const _queryState = {
        timeStamp: 0,
        value: ""
    }


    useEffect(() => {
        if (_pricetariffs.success === '' || !pricetariffsPending) {
            return;
        }
        if (_pricetariffs.success === true) {
            setPagination(_pricetariffs.pagination);
            setPricetariffs(_pricetariffs.data);
        }
        setPricetariffsPending(false);
        if (!pricetariffPending) {
            setInitialized(true);
        }
    }, [_pricetariffs]);

    useEffect(() => {
        if (_pricetariff.success === '' || !pricetariffPending) {
            return;
        }
        if (_pricetariff.success === true) {
            setPricetariff(_pricetariff.data);
        }
        setPricetariffPending(false);
        if (!pricetariffsPending) {
            setInitialized(true);
        }
    }, [_pricetariff]);

    useEffect(() => {
        if (_pricetariffValidFroms.success === '' || !pricetariffValidFromsPending) {
            return;
        }
        if (_pricetariffValidFroms.success === true) {
            setPricetariffValidFroms(_pricetariffValidFroms.data);
        }
        setPricetariffValidFromsPending(false);
        if (!pricetariffsPending && !pricetariffPending && !pricetariffValidFromPending) {
            setInitialized(true);
        }
    }, [_pricetariffValidFroms]);

    useEffect(() => {
        if (_pricetariffValidFrom.success === '' || !pricetariffValidFromPending) {
            return;
        }
        if (_pricetariffValidFrom.success === true) {
            setPricetariffValidFrom(_pricetariffValidFrom.data);
        }
        setPricetariffValidFromPending(false);
        if (!pricetariffsPending && !pricetariffPending && !pricetariffValidFromsPending) {
            setInitialized(true);
        }
    }, [_pricetariffValidFrom]);


    useEffect(() => {
        if (_pricetypes.success === '' || !pricetypesPending) {
            return;
        }

        setPricetypesPending(false);
        if (!pricesPending && !productsPending) {
            setExtrasReady(true);
        }
    }, [_pricetypes]);

    useEffect(() => {
        if (_prices.success === '' || !pricesPending) {
            return;
        }

        setPricesPending(false);
        if (!pricetypesPending && !productsPending) {
            setExtrasReady(true);
        }
    }, [_prices]);

    useEffect(() => {
        if (_products.success === '' || !productsPending) {
            return;
        }

        setProductsPending(false);
        if (!pricesPending && !pricetypesPending) {
            setExtrasReady(true);
        }
    }, [_products]);

    useEffect(() => {
        if (_deletePricetariff.success === '' || !deletePricetariffPending) {
            return;
        }
        setDeletePricetariffPending(false);
        if (_deletePricetariff.success === true) {
            showNotification('success', _deletePricetariff.data.id, null, 'pricetariff');
            dispatch(priceTariffsActions.getPriceTariffsResetData());
            setPricetariffsPending(true);
        } else {
            showNotification('warning', _deletePricetariff.data.id, _deletePricetariff.data.message, 'pricetariff');
        }
    }, [_deletePricetariff]);

    useEffect(() => {
        if (_patchPricetariff.success === '' || !pricetariffPending) {
            return;
        }
        setPricetariffPending(false);
        if (_patchPricetariff.success === true) {
            showNotification('success', _patchPricetariff.data.id, null, 'pricetariff');
            dispatch(priceTariffsActions.getPriceTariffsResetData());
            setPricetariffsPending(true);
        } else {
            showNotification('warning', _patchPricetariff.data.id, _patchPricetariff.data.message, 'pricetariff');
        }
    }, [_patchPricetariff]);


    const onClosePricetariff = () => {
        dispatch(priceTariffsActions.getPriceTariffsResetData());
       setInitialized(false);
        setPricetariffsPending(true);
        initialize();

    };

    const initialize = () => {
        if(initialized || pricetariffsPending || pricetariffPending || pricetariffValidFromsPending || pricetariffValidFromsPending) { return }
        let requestFilter = {...filters};
        requestFilter = {...requestFilter, page: pagination.current_page};
        requestFilter = {...requestFilter, limit: paginationLimit};
        requestFilter = {...requestFilter, ...allUrlParams};
        dispatch(priceTariffsActions.getPricetariffs({
            token: Biscuit.get('token'),
            filter: requestFilter,
            parameters: {
                headers: {
                    "Accept-Language": language
                }
            }
        }));
        setPricetariffsPending(true);
        if (params.pricetariffId !== null) {
            dispatch(priceTariffsActions.getPricetariff({
                token: Biscuit.get('token'),
                id: params.pricetariffId,
                parameters: {
                    headers: {
                        "Accept-Language": language
                    }
                }
            }));
            setPricetariffPending(true);
        }
        if (params.pricetariffValidFromId !== null) {
            dispatch(priceTariffValidFromsActions.getPricetariffValidFrom({
                id: params.pricetariffValidFromId,
                token: Biscuit.get('token'),
                parameters: {
                    headers: {
                        "Accept-Language": language
                    }
                }
            }));
        }
        dispatch(pricetypesActions.getPricetypes({
            token: Biscuit.get('token'),
            parameters: {
                headers: {
                    "Accept-Language": language
                }
            }
        }));
        dispatch(pricesActions.getPrices({
            token: Biscuit.get('token'),
            parameters: {
                headers: {
                    "Accept-Language": language
                }
            }
        }));
        dispatch(productsActions.getProducts({
            token: Biscuit.get('token'),
            filter: {
                'findForSelect': true,
                'limit': 1000
            },
            parameters: {
                headers: {
                    "Accept-Language": language
                }
            }
        }));
    }
    const onRemovePricetariff = (pricetariff) => {
        if (confirm(t('really_remove'))) {
            dispatch(priceTariffsActions.deletePricetariff(
                {
                    id: Number(pricetariff.id),
                    token: Biscuit.get('token')
                }
            ));
            setDeletePricetariffPending(true);
        }
    };

    const toggleValidFroms = (ev, id) => {
        const el = ev.currentTarget;
        const key = el.getAttribute('data-inb-val');
        $('#' + key).toggleClass('active');
        $('#row_' + id).toggleClass('toggled');

    };

    const onFilterChanged = (filter) => {
        setFilters(filter);
        props.dispatch(priceTariffsActions.getPricetariffs({
            token: Biscuit.get('token'),
            filter: filter
        }));
        setPricetariffsPending(true);
    };
    initialize();
    const onChangeSort = (ev) => {
        const el = ev.currentTarget;

        const sortKey = el.getAttribute('data-inb-val'),
            direction = el.getAttribute('data-inb-direction'),
            isOppositeElement = (direction === null && el.classList.contains('is-active')),
            newDirection = (direction === 'desc' || isOppositeElement ? 'asc' : 'desc');
        if (sortKey) {
            let filter = {
                sort: sortKey,
                direction: direction
            };
            setFilters(Object.assign(filters, filter));
            dispatch(priceTariffsActions.getPricetariffs({
                token: Biscuit.get('token'),
                filter: filters,
                headers: {
                    'AcceptLanguage': language,
                    'ContentLanguage': language
                }
            }));
            setPricetariffsPending(true);

            const activeSortTab = $('.is-active');
            _.each(activeSortTab, function (key, value) {
                key.classList.remove('is-active');
            });
            el.classList.add('is-active');
            el.setAttribute('data-inb-direction', (isOppositeElement ? 'desc' : newDirection));

        }

    };

    const onChangeStatus = (status, pricetariff) => {
        dispatch(priceTariffsActions.patchPricetariff({
            id: pricetariff.id,
            data: {
                status: status.target.value
            },
            token: Biscuit.get('token'),
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
        setPricetariffPending(true);
    };

    let tabs = [{
        name: t('name', null, 'capital'),
        mediumWidth: 6,
        smallWidth: 6,
        title: t('sort_by_${a}', {a: t('name')}),
        canSort: true,
        sort: {
            direction: null,
            data_inb_val: 'name'
        }
    }, {
        name: t('description', null, 'capital'),
        mediumWidth: 6,
        smallWidth: 5,
        title: t('sort_by_${a}', {a: t('description')}),
        canSort: true,
        sort: {
            direction: null,
            data_inb_val: 'description'
        }
    }];

    const submenuItems = createSubmenuItems('pricetariffs');


    const searchBarHandler = (ev) => {
        let query;
        if(typeof ev.target !== 'undefined') {
            query = ev.target.value.toLowerCase();
        } else {
            query = '';
        }

        const minLength = 1;
        if (query.length >= minLength) {
            // work user search only for values bigger or equal to the minimum length
            let standardFilter = {
                sort: "name",
                direction: "asc",
                page: 1,
                find: "full",
                limit: paginationLimit,
                ...allUrlParams
            };
            searchParams.delete('item');
            if(query !== '') {
                searchParams.set('q', query);
            }
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
            let filterA = standardFilter;
         //   setResetFilter(true);
            setTimeout(function () {

                let diff = Number(moment().format('x')) - _queryState.timeStamp;

                if (diff > 700 && _queryState.value === query) {                  // no changes after the last 700 ms -> user finished input -> start request
                    onFilterChanged({
                        ...filterA,
                        'q': query
                    });

                }
            },800);
        } else if (filters.q !== undefined) {
            // reset filter when query was active
            let clone = {...filters};
            delete clone.q;
            onFilterChanged(clone);
        }
        _queryState.timeStamp = Number(moment().format('x'));
        _queryState.value = query;
    };
    const loadNextPage = (page) => {

        // if (!pagination.has_next_page) return;

        setPricetariffsPending(true);

        if(page > 1){
            searchParams.set('page', page);
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        } else{
            searchParams.delete('page');
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }
        dispatch(priceTariffsActions.getPricetariffs({
            token: Biscuit.get('token'),
            filter: {
                ...filters,
                page: page,
                limit: paginationLimit
            },
            parameters: {
                headers: {
                    "Accept-Language": language
                }
            }
        }));
    };

    return (
        <>
            <PricetariffSidebar
                pricetariffs={props.pricetariffs}
                /* contingents={props.contingents}
                 contingentsAll={props.contingentsAll}
                 locations={props.locations}*/
                dispatch={dispatch}
                filters={filters}
                selectedEntity={selectedEntity}
                setSelectedEntity={setSelectedEntity}
                setSelectedFilter={onFilterChanged}
            />

            <div id="inb-c-main" className="columns">
                {props.createAccessBar &&
                    <InboomaSubmenu
                        tabs={submenuItems}
                        extraClasses={"sticky-top"}
                        smallOnlyTitle={t('pricetariffs', null, 'capital')}
                        searchbar={true}
                        searchbarPlaceholder={t('name')}
                        searchbarHandler={searchBarHandler}
                        pagination={pagination}
                        itemsCountPerPage={paginationLimit}
                        pageRangeDisplayed={5}
                        onChange={loadNextPage}
                        itemLength={pricetariffs.length}
                    />
                }
                <SortNav
                    tabs={tabs}
                    extraClasses={"sticky-top-sortbar"}
                    handler={onChangeSort}
                />
                    {initialized && pricetariffs.length > 0 && !pricetariffsPending &&
                       <PricetariffsList
                           pricetariffs={pricetariffs}
                           onRemovePricetariff={onRemovePricetariff}
                           toggleValidFroms={toggleValidFroms}
                           dispatch={dispatch}
                           />
                    }
                    {pricetariffsPending &&
                       <>
                           <div className="inb-c-loader">
                               <div className="inb-c-loader--item">
                                   <div className="inb-c-loader--bg row">
                                       <div className="loader-mask r-1 medium-offset-1 medium-1 column"></div>
                                       <div className="loader-mask r-1 medium-offset-4 medium-1 column"></div>
                                       <div className="loader-mask r-1 medium-offset-7 medium-1 column"></div>
                                       <div className="loader-mask r-1 medium-offset-10 medium-1"></div>
                                       <div className="loader-mask vert-ph-1"></div>
                                       <div className="loader-mask r-2 medium-offset-1 medium-1 column"></div>
                                       <div className="loader-mask r-2 medium-offset-4 medium-8 column"></div>
                                       <div className="loader-mask r-2 medium-offset-7 medium-1 column"></div>
                                       <div className="loader-mask r-2 medium-offset-10 medium-1"></div>
                                       <div className="loader-mask vert-ph-2"></div>
                                   </div>
                               </div>
                           </div>
                       </>
                    }
                    {initialized && !pricetariffsPending && pricetariffs.length < 1 &&
                        <>
                            <div
                                id="inb-app-collection-empty"
                                className="inb-announcement"
                                style={{minHeight: "1150px"}}
                            >
                                <div className="inb-image-box">
                                    <img alt="No Data" src={"assets/img/no_data.svg"}/>
                                </div>
                                <h3>
                                    {t('app_msg_collection_empty')}
                                </h3>
                                <p>
                                    {t('app_msg_collection_empty_body')}
                                </p>
                            </div>
                        </>
                    }
            </div>
            {(params.add || (params.pricetariffId !== null && !pricetariffPending && !pricetariffValidFromPending))  && _products.success !== '' && _pricetypes.success !== '' &&
                <SubItemView
                    onClose={onClosePricetariff}
                    dispatch={dispatch}
                    pricetypes={_pricetypes.data}
                    pricetariff={_pricetariff.data}
                    products={_products.data}
                    productId={params.productId}
                    pricetariffValidFrom={_pricetariffValidFrom.data}
                    selectedPricetariff={_pricetariffValidFrom.data}
                    pricetariffStatus={_pricetariff.data}
                    pricetariffValidFromStatus={_pricetariffValidFrom.data}
                    showNotification={showNotification}
                    returnPath={returnPath}
                />
            }
        </>
    );
}

export default PricetariffsView;